module.exports = __webpack_public_path__ + "img/checking.e2aba5fa.svg";